export default __webpack_public_path__ + "static/media/goods.7ec1f63c.svg";